const getDefaultPortfolioState = () => {
    return {
        planType: null,
        riskProfile: null,
        investmentType: null,
        investmentAmount: null,
        loanTicketId: null,
        lenderInterestRate: null,
        isInTransaction: false,
        status: 'notCreated',
        portfolioId: null
    }
}

export const portfolio = {
    namespaced: true,
    state: getDefaultPortfolioState(),
    getters: {
        getCartInvestment: (state) => {
            if (state.investmentType === 'manual') {
                return {
                    investmentType: state.investmentType,
                    investmentAmount: state.investmentAmount,
                    lenderInterestRate: state.lenderInterestRate,
                    loanTicketId: state.loanTicketId
                }
            } else {
                return {
                    planType: state.planType,
                    riskProfile: state.riskProfile,
                    investmentType: state.investmentType,
                    investmentAmount: state.investmentAmount
                }
            }
        },
        getPortfolio: (state) => {
            return {
                portfolioId: state.portfolioId,
                planType: state.planType,
                riskProfile: state.riskProfile,
                investmentType: state.investmentType,
                investmentAmount: state.investmentAmount,
                status: state.status
            }
        }
    },
    actions: {
    },
    mutations: {
        setPortfolio (state, data) {
            Object.keys(data).forEach((item) => {
                state[item] = data[item]
            })
        },
        setField (state, data) {
            state[data.field] = data.value
        },
        setManualInvestment (state, data) {
            state.loanTicketId = data.loanTicketId
            state.investmentType = data.investmentType
            state.investmentAmount = data.investmentAmount
            state.lenderInterestRate = data.lenderInterestRate
        },
        reset (state) {
            const initialState = getDefaultPortfolioState()
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key]
            })
        }
    }
}
